/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ObservableRichText.ts
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 1117
 * ---
 * Description:
 */

import {
  defaultSetterOptions,
  ObservableSetterOptions,
  ObservableShape
}                                                       from './ObservableShape';
import Pamela
                                                        from '@revodigital/pamela';
import { action, computed, makeObservable, observable } from 'mobx';
import {
  HorizontalAlignment
}                                                       from '@revodigital/pamela/lib/configuration/Alignment';
import {
  RichTextSource
}                                                       from '@revodigital/pamela/lib/shapes/RichText';

export class ObservableRichText extends ObservableShape<Pamela.RichText> {
  @observable
  private _htmlContent: string;
  @observable
  private _lockSize: boolean;
  @observable
  private _padding: number;
  @observable
  private _backgroundColor: string;
  @observable
  private _fontSize: number;
  @observable
  private _horizontalAlignment: HorizontalAlignment;
  @observable
  private _fontFamily: string;
  @observable
  private _fontStyle: string;

  constructor(shape: Pamela.RichText, editor: any) {
    super(shape, editor);
    this._htmlContent = shape.htmlContent();
    this._lockSize = shape.lockSize();
    this._padding = shape.padding();
    this._backgroundColor = shape.backgroundColor();
    this._fontSize = shape.fontSize();
    this._horizontalAlignment = shape.horizontalAlignment();
    this._fontFamily = shape.fontFamily();
    this._fontStyle = shape.fontStyle();

    makeObservable(this,);
  }

  @computed
  public get htmlContent() {
    return this._htmlContent;
  }

  @computed
  public get fontFamily() {
    return this._fontFamily;
  }

  @computed
  public get lockSize() {
    return this._lockSize;
  }

  @computed
  public get margin() {
    return this._padding;
  }

  @computed
  public get backgroundColor() {
    return this._backgroundColor;
  }

  @computed
  public get fontStyle() {
    return this._fontStyle;
  }

  @computed
  public get fontSize() {
    return this._fontSize;
  }

  @computed
  public get horizontalAlignment() {
    return this._horizontalAlignment;
  }

  @action
  public setFontSize(value: number, optinos: ObservableSetterOptions = defaultSetterOptions) {
    this._fontSize = value;

    if (optinos.applyToPamelaShape) this.pamelaShape__nonObservable.fontSize(
      value);
  }

  @action
  public setHtmlContent(value: string, optinos: ObservableSetterOptions = defaultSetterOptions) {
    this._htmlContent = value;

    if (optinos.applyToPamelaShape) this.pamelaShape__nonObservable.setContent(
      value, RichTextSource.Html);
  }

  @action
  public setLockSize(value: boolean, optinos: ObservableSetterOptions = defaultSetterOptions) {
    this._lockSize = value;

    if (optinos.applyToPamelaShape) this.pamelaShape__nonObservable.lockSize(
      value);
  }

  @action
  public setMargin(value: number, optinos: ObservableSetterOptions = defaultSetterOptions) {
    this._padding = value;

    if (optinos.applyToPamelaShape) this.pamelaShape__nonObservable.padding(
      value);
  }

  @action
  public setBackgroundColor(value: string, optinos: ObservableSetterOptions = defaultSetterOptions) {
    this._backgroundColor = value;

    if (optinos.applyToPamelaShape) this.pamelaShape__nonObservable.backgroundColor(
      value);
  }

  @action
  public setHorizontalAlignment(value: HorizontalAlignment, optinos: ObservableSetterOptions = defaultSetterOptions) {
    this._horizontalAlignment = value;

    if (optinos.applyToPamelaShape) this.pamelaShape__nonObservable.horizontalAlignment(
      value);
  }

  @action
  public setFontFamily(value: string, optinos: ObservableSetterOptions = defaultSetterOptions) {
    this._fontFamily = value;

    if (optinos.applyToPamelaShape) this.pamelaShape__nonObservable.fontFamily(
      value);
  }

  @action
  public setFontStyle(value: string, optinos: ObservableSetterOptions = defaultSetterOptions) {
    this._fontStyle = value;

    if (optinos.applyToPamelaShape) this.pamelaShape__nonObservable.fontStyle(
      value);
  }
}